module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image1_bg-f22ccfd5c44cec1a6dbdbe46196f5f28.png";